import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component , OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageEnum } from '@shared/enums/language.enum';
import { NavBarItem } from '@shared/model/nav-bar-item';
import { LayoutService } from '@shared/services/layout.service';
import { BaseComponent } from '../base-component/base.component';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { RoutesUtil } from '@shared-features/utils/routes.util';
import { combineLatest } from 'rxjs';
import { LanguageService } from '@shared/services/language.service';
import { MatDialog } from '@angular/material/dialog';
import { OpsScoreDialogComponent } from '@layout/components/ops-score-dialog/ops-score-dialog.component';
import { NavListService } from '@layout/services/nav-list.service';
import { UserRole } from '@shared/enums/user-role.enum';


@Component({
  selector: 'app-avatar-Menu',
  templateUrl: './avatar-menu.component.html',
  styleUrls: ['./avatar-menu.component.scss'],
})
export class AvatarMenuComponent extends BaseComponent implements OnInit {
  public userFirstName = '';
  public userLastName = '';
  public userEmail = '';

  userRole: UserRole[];
  language = LanguageEnum;
  currentLang: LanguageEnum;
  public navigationItems: NavBarItem[];
  sideMenuActive = false;
  toggleMenu = false;
  position: ConnectedPosition = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  };
  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    public layoutService: LayoutService,
    private languageService: LanguageService,
    private matDialogService: MatDialog,
    public navService: NavListService
  ) {
    super();
    navService.action$.pipe(takeUntil(this.destroy$)).subscribe((action) => {
      if (action === 'myScore') {
        this.openScoreDialog();
      }
      if (action === 'logout') {
        this.logout();
      }
    });
  }

  ngOnInit() {
    this.userFirstName = this.authService.currentUser$.value?.firstName;
    this.userLastName = this.authService.currentUser$.value?.lastName;
    this.userEmail = this.authService.currentUser$.value?.email;
    this.userRole = this.authService.currentUser$.value.userRoles;
    this.languageService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang.isoCode;
    });

    this.layoutService.websiteDirection$.pipe(takeUntil(this.destroy$)).subscribe((_) => {
      this.setupNavBarItems();
    });
  }

  logout(): void {
    this.authService.logout().pipe(take(1)).subscribe();
  }

  setLanguage(language: LanguageEnum): void {
    this.languageService.changeLanguage(language);
  }

  openScoreDialog(): void {
    this.matDialogService.open(OpsScoreDialogComponent);
  }


  private setupNavBarItems(): void {
    combineLatest([this.translateService.get(['avatarMenu'])])
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe(([translations]: any) => {
        const { avatarMenu } = translations;

        this.navigationItems = [
          {
            title: avatarMenu.MyScore,
            icon: 'chart',
            action: 'myScore',
            isVisible: true,
          },

          // {
          //   title: avatarMenu.MyTickets,
          //   icon: 'bulk-ticket',
          //   isVisible: true,
          //   path: RoutesUtil.SupportTickets.url(),
          // },
          // {
          //   title: avatarMenu.ReleaseNotes,
          //   icon: 'bulk-star',
          //   path: RoutesUtil.ReleaseNotes.url(),
          //   isVisible: true,
          // },
          {
            title: avatarMenu.Payment,
            icon: 'money',
            isVisible: true,
          },
          {
            title: avatarMenu.Settings,
            path: RoutesUtil.Settings.url(),
            icon: 'settings',
            isVisible: true,
          },
          {
            title: avatarMenu.logout,
            icon: 'logout',
            action: 'logout',
            isVisible: true,
          },
        ];
      });
  }
}
